import React, { useState, useEffect } from 'react';
import { Container, Button, Modal, Row, Col, Spinner, Form, Alert } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import { ApiManager } from '../../../core/api-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "lodash";
import { settings } from '../../../config/settings';


export default function ModalEntityExport({ entity, props, entityPreferences, status, close, params, searchObj }) {


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState('');


    useEffect(() => {
        if(data !== null) {
            console.log(data)

            const items = data
            const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
            const header = Object.keys(items[0])
            const csv = [
            header.join(','), // header row first
            ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
            ].join('\r\n')

            //console.log(csv)
            
            var link = document.createElement('a');
            link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
            link.setAttribute('download', 'export-'+entity+'-'+new Date().toISOString().slice(0,10)+'.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Reset after download
            setData(null);
            closeModal();
        }
    }, [data]);


    function closeModal() {
        setLoading(false)
        setData(null)
        setError('')
        close()
    }

    async function exportPage() {
        if(loading === false) {
            setLoading(true)
            setError('')
            
            // Always use export for import (with labels)
            await exportForImport(params.page || 1, params.limit || 100000);
        }
    }

    async function exportAll() {
        if(loading === false) {
            setLoading(true)
            setError('')
            
            // Always use export for import (with labels)
            await exportForImport(1, 100000);
        }
    }
    
    async function exportForImport(page, limit) {
        try {
            const response = await ApiManager.sendAuthenticatedRequest('/utils/export_for_import', {
                entity: entity,
                offset: (page - 1) * limit,
                limit: limit,
                order: params.sortingField + ' ' + params.sortingOrder,
                query: searchObj.query || null,
                fields: searchObj.fields || null,
                constraints: searchObj.constraints || null
            });
            
            if (response.success === 1 && response.data) {
                // Download the file (Excel or CSV)
                const binaryString = atob(response.data.content);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([bytes], { type: response.data.mimetype });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = response.data.filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
                
                // Close modal after successful download
                closeModal();
            } else {
                setError(response.message || 'Export failed');
            }
        } catch (e) {
            setError('Error exporting data');
        }
        
        setLoading(false)
    }


    if(props !== null && status !== false) { 
        return (
            <>
                <Modal show={status} onHide={closeModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{LanguageProvider.get('defaults.export')} - {LanguageProvider.get('entity.'+entity)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loading === false &&
                            <Container className='mb-4'>
                                <h5>Export Options</h5>
                                <p className="text-muted">Data will be exported with external references as labels for easy re-import.</p>
                                
                                <Row>
                                    <Col md={6}>
                                        <Button variant="primary" onClick={exportPage} className='w-100'>
                                            <FontAwesomeIcon icon="download" className="me-2" />
                                            {LanguageProvider.get('defaults.export_page')}
                                        </Button>
                                        <Form.Text className="text-muted">
                                            Export current page with applied filters
                                        </Form.Text>
                                    </Col>
                                    <Col md={6}>
                                        <Button variant="success" onClick={exportAll} className='w-100'>
                                            <FontAwesomeIcon icon="download" className="me-2" />
                                            {LanguageProvider.get('defaults.export_all')}
                                        </Button>
                                        <Form.Text className="text-muted">
                                            Export all records with applied filters
                                        </Form.Text>
                                    </Col>
                                </Row>
                                
                                {error && (
                                    <Alert variant="danger" className="mt-3">
                                        {error}
                                    </Alert>
                                )}
                                
                                <Alert variant="info" className="mt-4">
                                    <h6>Export Information:</h6>
                                    <ul className="mb-0 small">
                                        <li>The exported file will be in Excel (.xlsx) format</li>
                                        <li>Import-compatible format includes ID column for updates</li>
                                        <li>System fields (date, lastUpdate, deleted) are excluded</li>
                                        <li>Private fields are not exported</li>
                                    </ul>
                                </Alert>
                            </Container>
                        }
                        {loading === true &&
                            <div className='text-center p-5'>
                                <Spinner animation="border" />
                                <p className='mt-3'>Preparing export...</p>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModal}>
                            {LanguageProvider.get('defaults.close')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
};